const fitment: Map<string, string> = new Map([
  ['getPageInfo', '/fleshopy/decoration/getDecorationContent'], // 获取装修详情
  ['userPageInfo', '/fleshopy/decoration/cuser/getById'], // 获取装修详情
  ['getHomeIndexId', '/fleshopy/decoration/getHomeIndexId'], // 获取装修详情
  ['getOutHomeIndexId', '/fleshopy/decoration/cuser/getHomeIndexIdV2'], // 获取外部装修详情id
]);

export default fitment;
